var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveViewmodeNormscreen40(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4C12.95,4,4,12.95,4,24s8.95,20,20,20,20-8.95,20-20S35.05,4,24,4ZM24,42c-9.93,0-18-8.07-18-18S14.07,6,24,6s18,8.07,18,18-8.07,18-18,18Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.41,29h1.41c.55,0,1-.45,1-1s-.45-1-1-1h-3.82c-.13,0-.26.03-.38.08-.24.1-.44.3-.54.54-.05.12-.08.25-.08.38v3.82c0,.55.45,1,1,1s1-.45,1-1v-1.41l5.29,5.29c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-5.29-5.29Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15.18c-.55,0-1,.45-1,1v1.41l-5.29-5.29c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l5.29,5.29h-1.41c-.55,0-1,.45-1,1s.45,1,1,1h3.82c.13,0,.26-.03.38-.08.24-.1.44-.3.54-.54.05-.12.08-.25.08-.38v-3.82c0-.55-.45-1-1-1Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29,12.29l-5.29,5.29v-1.41c0-.55-.45-1-1-1s-1,.45-1,1v3.82c0,.13.03.26.08.38.1.24.3.44.54.54.12.05.25.08.38.08h3.82c.55,0,1-.45,1-1s-.45-1-1-1h-1.41l5.29-5.29c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.38,27.08c-.12-.05-.25-.08-.38-.08h-3.82c-.55,0-1,.45-1,1s.45,1,1,1h1.41l-5.29,5.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5.29-5.29v1.41c0,.55.45,1,1,1s1-.45,1-1v-3.82c0-.13-.03-.26-.08-.38-.1-.25-.3-.44-.54-.54Z",
    fill: "#030303",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveViewmodeNormscreen40);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-viewmode-normscreen-40.4ff7570ab19d963e5343a0eb885282d1.svg";
export { ForwardRef as ReactComponent };